/**
 * Chain Cart Lock
 * Blockiert Quantity-Änderungen im Cart-Drawer UND auf /cart für Chain-Items.
 * Erlaubt weiterhin das Entfernen (quantity=0).
 */
(function () {
  'use strict';

  // Muss ALLE Locale-Werte von chain_configurator.cart_property enthalten:
  // Der Property-Name wird beim Hinzufügen gespeichert, ein Warenkorb kann
  // also Zeilen aus einer anderen Sprache enthalten.
  var CHAIN_MARKERS = ['Cut', 'Zuschnitt'];
  var NOTE_CLASS = 'chain-cart-lock-note';
  // Übersetzter Text kommt aus theme.liquid (window.chainCartLockNote)
  var DEFAULT_NOTE = 'To change length or quantity, please remove this item and reconfigure it.';

  function isLineElement(el) {
    if (!el) return false;
    if (el.classList) {
        if (el.classList.contains('line-item')) return true;
        if (el.classList.contains('cart-drawer__item')) return true;
        if (el.classList.contains('cart-item')) return true;
    }
    var tag = el.tagName;
    if (tag === 'LINE-ITEM' || tag === 'CART-ITEM') return true;

    if (tag === 'TR' && el.closest && el.closest('.order-summary, .cart-page, form[action*="/cart"]')) {
        return true;
    }
    return false;
    }

  function findCartLine(el) {
    var current = el;
    while (current && current !== document.body) {
      if (isLineElement(current)) return current;
      current = current.parentElement;
    }
    return null;
  }

  function isChainLine(line) {
    if (!line) return false;
    var text = line.textContent || '';
    for (var i = 0; i < CHAIN_MARKERS.length; i++) {
      if (text.indexOf(CHAIN_MARKERS[i] + ':') !== -1) return true;
    }
    return false;
  }

  function isRemoveAction(el) {
    if (!el) return false;
    var href = el.getAttribute && el.getAttribute('href');
    if (href) {
      var m = href.match(/[?&]quantity=(\d+)/);
      if (m && m[1] === '0') return true;
    }
    var text = (el.textContent || '').toLowerCase().trim();
    if (text === 'remove' || text === 'entfernen' || text === 'delete') return true;
    var aria = (el.getAttribute && el.getAttribute('aria-label') || '').toLowerCase();
    if (aria.indexOf('remove') !== -1 || aria.indexOf('delete') !== -1 || aria.indexOf('entfernen') !== -1) return true;
    if (el.closest && el.closest('[data-action="remove"], .cart-item__remove, .line-item__remove, cart-remove-button')) return true;
    return false;
  }

  function isQuantityChange(el) {
    if (!el || !el.getAttribute) return false;
    var href = el.getAttribute('href');
    if (!href) return false;
    var m = href.match(/[?&]quantity=(\d+)/);
    if (!m) return false;
    return m[1] !== '0';
  }

  function showLockNote(line) {
    if (line.querySelector('.' + NOTE_CLASS)) return;
    var note = document.createElement('div');
    note.className = NOTE_CLASS;
    note.style.cssText = [
      'font-size: 0.8125rem',
      'margin-top: 0.5rem',
      'padding: 0.5rem 0.75rem',
      'background: rgba(220,38,38,0.08)',
      'color: rgb(185,28,28)',
      'border-radius: 4px',
      'line-height: 1.4'
    ].join(';');
    note.textContent = window.chainCartLockNote || DEFAULT_NOTE;
    line.appendChild(note);
    setTimeout(function () {
      if (note && note.parentElement) note.parentElement.removeChild(note);
    }, 4000);
  }

  function dimQuantitySelector(line) {
    if (line.dataset.chainLocked === 'true') return;
    line.dataset.chainLocked = 'true';
    var qty = line.querySelector(
      'quantity-selector, .quantity-selector, line-item-quantity, ' +
      '.cart-item__quantity-input, input[name^="updates"]'
    );
    if (qty) qty.style.opacity = '0.4';
  }

  function scanAndMark() {
    var lines = document.querySelectorAll(
        '.line-item, .cart-drawer__item, .cart-item, LINE-ITEM, CART-ITEM, ' +
        '.order-summary tbody tr, form.cart-page tbody tr'
    );
    for (var i = 0; i < lines.length; i++) {
        if (isChainLine(lines[i])) dimQuantitySelector(lines[i]);
    }
    }

  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!target.closest) return;

    var clickable = target.closest(
      '.quantity-selector__button, ' +
      'quantity-selector a, quantity-selector button, ' +
      '.quantity-selector a, .quantity-selector button, ' +
      'a[href*="/cart/change"]'
    );
    if (!clickable) return;

    if (isRemoveAction(clickable)) return;
    if (!isQuantityChange(clickable) && !clickable.matches('.quantity-selector__button, quantity-selector button, .quantity-selector button')) {
      return;
    }

    var line = findCartLine(clickable);
    if (!isChainLine(line)) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    showLockNote(line);
  }, true);

  function blockQuantityInput(e) {
    var target = e.target;
    if (!target.matches) return;
    if (!target.matches(
      'quantity-selector input, .quantity-selector input, ' +
      'input[name^="updates"], input.cart-item__quantity-input'
    )) return;

    var line = findCartLine(target);
    if (!isChainLine(line)) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    target.blur();
    showLockNote(line);
  }

  document.addEventListener('input', blockQuantityInput, true);
  document.addEventListener('change', blockQuantityInput, true);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var target = e.target;
    if (!target.matches) return;
    if (!target.matches('input[name^="updates"], .quantity-selector input, quantity-selector input')) return;
    var line = findCartLine(target);
    if (!isChainLine(line)) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    target.blur();
    showLockNote(line);
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches) return;
    if (!form.matches('form[action="/cart"], form[action$="/cart"], form[data-cart-form], form.cart-page')) return;

    var inputs = form.querySelectorAll('input[name^="updates"]');
    for (var i = 0; i < inputs.length; i++) {
      var inp = inputs[i];
      var line = findCartLine(inp);
      if (!isChainLine(line)) continue;
      var originalValue = inp.defaultValue;
      if (String(inp.value) !== String(originalValue)) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        inp.value = originalValue;
        showLockNote(line);
        return;
      }
    }
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanAndMark);
  } else {
    scanAndMark();
  }

  var events = ['cart:refresh', 'cart:change', 'cart:refresh:complete', 'cart:item-added', 'shopify:section:load'];
  for (var i = 0; i < events.length; i++) {
    document.addEventListener(events[i], function () {
      setTimeout(scanAndMark, 150);
    });
  }

  if (typeof MutationObserver !== 'undefined') {
    var observer = new MutationObserver(scanAndMark);
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();